import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";


export const getVisitasDetalleDate = async(fechas, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas/Detalle/listado`, 'POST', fechas, token)
    return result;
}